import React from 'react';

const QuizQuestion = ({ question, index, isAnswered, onAnswerChange }) => {
  return (
    <div className="bg-apple-gray-50 p-6 rounded-lg border border-apple-gray-200">
      <div className="flex items-start space-x-4">
        <div className="flex-shrink-0 w-8 h-8 bg-apple-gray-800 text-white rounded-full flex items-center justify-center text-sm font-semibold">
          {index + 1}
        </div>
        <div className="flex-grow">
          <p className="text-apple-gray-800 font-medium mb-4 leading-relaxed">
            {question.text}
          </p>
          <div className="flex items-center space-x-4 mb-4">
            <span className="text-sm font-medium text-apple-gray-600">No</span>
            <button
              role="switch"
              aria-checked={isAnswered}
              aria-label={question.text}
              onClick={() => onAnswerChange(question.id, isAnswered)}
              className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-apple-gray-500 focus:ring-offset-2 ${isAnswered === true ? 'bg-apple-gray-800' : 'bg-apple-gray-300'
                }`}
            >
              <span
                className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${isAnswered === true ? 'translate-x-6' : 'translate-x-1'
                  }`}
              />
            </button>
            <span className="text-sm font-medium text-apple-gray-600">Yes</span>
          </div>

          {/* Risk Warning - appears when answer is No */}
          <div
            hidden={isAnswered !== false}
            className={`transition-all duration-300 ease-in-out ${isAnswered === false
              ? 'opacity-100 transform translate-y-0'
              : 'opacity-0 max-h-0 transform -translate-y-2 overflow-hidden'
              }`}
          >
            <div className="bg-apple-gray-50 border-l-4 border-red-400 p-3 rounded-r-lg">
              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <svg className="h-4 w-4 text-apple-gray-600 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                  </svg>
                </div>
                <div className="ml-2">
                  <p className="text-sm text-apple-gray-800 font-medium">Risk:</p>
                  <p className="text-sm text-apple-gray-600 mt-1">{question.risk}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuizQuestion;